class assignmentsUnassignedController {
  constructor(modalLoaderService, onConfirmation, onCancel) {
    this.name = 'assignmentsUnassigned';
    this.modalLoaderService = modalLoaderService;
    this.onConfirmation = onConfirmation;
    this.onCancel = onCancel;
  }

  close() {
    this.modalLoaderService.close();
    this.onCancel();
  }

  confirm() {
    this.modalLoaderService.close();
    this.onConfirmation();
  }
}

assignmentsUnassignedController.$inject = ['modalLoaderService', 'onConfirmation', 'onCancel'];

export
default assignmentsUnassignedController;



// WEBPACK FOOTER //
// ./app/components/assignmentsUnassigned/assignmentsUnassigned.controller.js